var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isOnline)?_c('div',{staticClass:"ta-bidding-offline-overlay"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }